var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "vs-popup",
    {
      attrs: {
        fullscreen: "",
        title: "Resumo de Convidados",
        active: _vm.show
      },
      on: {
        "update:active": function($event) {
          return _vm.$emit("update:show")
        }
      }
    },
    [
      _vm.scheduleSuggestion
        ? [
            _c("p", { staticClass: "py-2" }, [
              _vm._v(" Situação de convidados "),
              _vm.event && _vm.event.title
                ? _c("span", [
                    _vm._v("da agenda "),
                    _c("b", [_vm._v('"' + _vm._s(_vm.event.title) + '" ')])
                  ])
                : _vm._e(),
              _vm._v("para a período "),
              _c("i", { staticClass: "font-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.formatDate(_vm.scheduleSuggestion.suggestion_start_at)
                  )
                )
              ]),
              _vm._v(" até "),
              _c("i", { staticClass: "font-bold" }, [
                _vm._v(
                  _vm._s(
                    _vm.formatDate(_vm.scheduleSuggestion.suggestion_finish_at)
                  )
                )
              ])
            ]),
            _c("guests-table", {
              attrs: {
                guests: _vm.formattedAndFilteredGuests,
                fields: [
                  { key: "situation", label: "Situação" },
                  { key: "name", label: "Nome" },
                  { key: "email", label: "Email" }
                ]
              },
              on: {
                "open-justifications": function($event) {
                  return _vm.$emit("open-justifications", $event)
                }
              },
              scopedSlots: _vm._u(
                [
                  {
                    key: "situation",
                    fn: function(situation) {
                      return [
                        _c(
                          "span",
                          {
                            class: [
                              {
                                REJ: "text-danger",
                                CON: "text-success",
                                CONREJ: "text-purple",
                                PEN: "text-warning"
                              }[situation.guest.situation]
                            ]
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.$t(
                                    "schedule_guest.situation." +
                                      situation.guest.situation
                                  )
                                ) +
                                " "
                            )
                          ]
                        ),
                        situation.guest.situation === "REJ"
                          ? [
                              _c(
                                "b-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: {
                                        content: "Abrir justificativa",
                                        duration: { show: 100, hide: 100 }
                                      },
                                      expression:
                                        "{content:'Abrir justificativa', duration:{show:100, hide:100}}"
                                    }
                                  ],
                                  attrs: {
                                    pill: "",
                                    size: "sm",
                                    variant: "outline-warning"
                                  },
                                  on: {
                                    click: function($event) {
                                      return _vm.$emit(
                                        "open-justifications",
                                        situation.guest
                                      )
                                    }
                                  }
                                },
                                [
                                  _c("b-icon-exclamation-triangle", {
                                    staticClass: "text-warning",
                                    attrs: { "font-scale": "1" }
                                  })
                                ],
                                1
                              )
                            ]
                          : _vm._e()
                      ]
                    }
                  }
                ],
                null,
                false,
                1959007651
              )
            })
          ]
        : _vm._e()
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }